<template>
    <div id="nasional-report" data-app>
      <div class="gutter-b">
          <b-button v-b-toggle.collapse-filter variant="white" size="lg" class="bg-white font-weight-bolder w-100">Filtering Data</b-button>
          <b-collapse :visible="visible" id="collapse-filter">
              <ValidationObserver ref="formAdd">
              <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                  <div class="card card-custom card-stretch">
                      <div class="card-body d-flex p-0 bg-white">
                          <div class="flex-grow-1 p-8 card-rounded bgi-no-repeat d-flex align-items-center">  
                              <div class="row w-100">
                                  <div class="col-12 col-sm-6">
                                      <validationProvider name="Display" rules="required" v-slot="{ valid, errors }">
                                      <b-form-group
                                      id="input-group-2"
                                      label="Display:"
                                      label-for="input-2"
                                      :state="valid"
                                      :invalid-feedback="errors[0]"
                                      class="m-0"
                                      >
                                          <b-form-select2
                                          id="input-2"
                                          v-model="filter.display"
                                          variant="solid"
                                          size="lg"
                                          :options="opsDisplay"
                                          placeholder="Silahkan pilih Display"
                                          :state="valid"
                                          ></b-form-select2>
                                      </b-form-group>
                                      </validationProvider>
                                  </div>
                                  <div class="col-12 col-sm-6">
                                      <validationProvider name="Data" rules="required" v-slot="{ valid, errors }">
                                      <b-form-group
                                      id="input-group-1"
                                      label="Data:"
                                      label-for="input-1"
                                      :state="valid"
                                      :invalid-feedback="errors[0]"
                                      class="m-0"
                                      >
                                          <b-form-select2
                                          id="input-1"
                                          v-model="filter.kategori"
                                          variant="solid"
                                          size="lg"
                                          :options="opsDataFilter"
                                          placeholder="Silahkan pilih Data"
                                          :state="valid"
                                          ></b-form-select2>
                                      </b-form-group>
                                      </validationProvider>
                                  </div>           
                                  <div class="col-12 col-sm-6">
                                      <validationProvider :name="`Periode`" v-slot="{ errors, valid }">
                                      <b-form-group
                                      id="input-group-4"
                                      label="Periode:"
                                      label-for="input-4"
                                      class="m-0"
                                      :invalid-feedback="errors[0]"
                                      :state="valid"
                                      >
                                          <b-button 
                                          type="button"
                                          id="input-4"
                                          class="form-control form-control-solid text-left" 
                                          variant="outline-secondary" 
                                          size="lg"
                                          @click="modalDate = true">{{ showDate }}
                                          </b-button>
                                      </b-form-group>
                                      </validationProvider>
                                  </div>
                                  <template v-if="kategoryChickin.includes(filter.kategori)">
                                    <div class="col-12 col-sm-6">
                                      <validationProvider :name="`Populasi`" rules="required" v-slot="{ errors, valid }">
                                      <b-form-group 
                                      id="input-group-5" 
                                      label="Populasi:"
                                      label-for="input-5"
                                      :invalid-feedback="errors[0]"
                                      :state="valid">
                                          <treeselect
                                          id="input-5"
                                          :multiple="true"
                                          required
                                          :options="opsPopulasi"
                                          :normalizer="normalizer"
                                          :flatten-search-results="true"
                                          placeholder="Silahkan pilih Populasi"
                                          v-model="filter.populasi"
                                          />
                                      </b-form-group>
                                      </validationProvider>
                                    </div>
                                  </template>
                                  <template v-if="kategorySetting.includes(filter.kategori)">
                                    <div class="col-12 col-sm-6">
                                      <validationProvider :name="`Setting`" rules="required" v-slot="{ errors, valid }">
                                      <b-form-group 
                                      id="input-group-6" 
                                      label="Setting:"
                                      label-for="input-6"
                                      :invalid-feedback="errors[0]"
                                      :state="valid">
                                          <treeselect
                                          id="input-6"
                                          :multiple="true"
                                          required
                                          :options="opsSettingSE"
                                          :normalizer="normalizerSHR"
                                          :flatten-search-results="true"
                                          placeholder="Silahkan pilih Setting"
                                          v-model="filter.setting_he"
                                          />
                                      </b-form-group>
                                      </validationProvider>
                                    </div>
                                  </template>
                              </div>
                          </div>
                      </div>
                      <div class="card-footer">
                          <button  
                          type="submit"
                          ref="kt_submit"
                          class="btn btn-primary font-weight-bold"
                          >
                          Tampilkan
                          </button>
                      </div>
                  </div>
              </b-form>
              </ValidationObserver>
          </b-collapse>
      </div>
  
      <component v-if="curComponent" :sdata="filter" v-bind:is="curComponent"></component>
  
      <v-dialog
          ref="dialogDate"
          v-model="modalDate"
          persistent
          width="290px"
      >
          <v-date-picker
          v-model="dates"
          scrollable
          range
          color="bg-primary"
          header-color="bg-primary"
          >
          <v-spacer></v-spacer>
          <v-btn
              text
              color="primary"
              @click="modalDate = false"
          >
              Cancel
          </v-btn>
          <v-btn
              text
              color="primary"
              @click="setDate()"
          >
              OK
          </v-btn>
          </v-date-picker>
      </v-dialog>
  
    </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
  
  import ReportService from "@/core/services/api/nasional/report.service";
  import ErrorService from "@/core/services/error.service";
  
  import ChartTemplate from "@/view/pages/nasional/report/_weekly/Chart.vue"
  import TableTemplate from "@/view/pages/nasional/report/_weekly/Table.vue"
  
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  export default {
    name: "nasional-report",
    components: {
        ChartTemplate,
        TableTemplate,
        Treeselect
    },
    data() {
      return {
          show: true,
          modalDate: false,
          isBusy: true,
          dates: [],
          visible: true,
          filter: {
              display: null,
              tgl_awal: null,
              tgl_akhir: null,
              kategori: null,
              strain: null,
              populasi: [],
              setting_he: [],
              title: null
          },
          curComponent: null,
          kategoryChickin: ['produksi-he', 'produksi-telur', 'populasi-produktif'],
          kategorySetting: ['produksi-doc', 'hatchebility', 'fertility', 'hatchebility-rerata', 'fertility-rerata'],
          opsData: [
              { theme: null, value: null, text: "Silahkan pilih Data" },
              { theme: 'TableTemplate', value: 'produksi-he', text: "Produksi HE seluruh Strain menurut umur (weekly dan kumulatif WOP)" },
              { theme: 'TableTemplate', value: 'produksi-telur', text: "Produksi telur seluruh Strain menurut umur (weekly dan kumulatif WOP)" },
            //   { theme: 'TableTemplate', value: 'populasi-produktif', text: "Standing populasi (populasi produktif) menurut strain (weekly dan kumulatif WOP)" },
            //   { theme: 'TableTemplate', value: 'produksi-doc', text: "Produksi DOC (saleable chick) per strain  (weekly dan kumulatif WOP)" },
              { theme: 'TableTemplate', value: 'hatchebility', text: "Hatchebility menurut WOP per strain (persetase)" },
              { theme: 'TableTemplate', value: 'fertility', text: "Fertility menurut WOP per strain (persetase)" },
            //   { theme: 'TableTemplate', value: 'hatchebility-rerata', text: "Rerata hatchability per strain (persetase)" },
            //   { theme: 'TableTemplate', value: 'fertility-rerata', text: "Rerata Fertility per strain (persetase)" },
          ],
          opsDisplay: [
              { value: null, text: "Silahkan pilih Output" },
              { value: 'TableTemplate', text: "Table" },
              { value: 'ChartTemplate', text: "Chart" },
          ],
          opsPopulasi: [],
          opsSettingSE: [],
      }
    },
    computed: {
      ...mapGetters(["currentUser"]),
      showDate() {
          return (this.filter.tgl_awal || this.filter.tgl_akhir ? `${this.filter.tgl_awal} ~ ${this.filter.tgl_akhir}` : 'Silahkan klik untuk pilih tanggal')
      },
        opsDataFilter () {
            return this.opsData.filter((item) => {
                return item.theme == this.filter.display ||
                    item.theme == null
            });
        }
    },
    watch: {
      'filter.display' (val, old) {
        if (val != old) {
            this.filter.kategori = null
        }
      },
      'filter.kategori' (val, old) {
        this.filter.populasi = []
        this.filter.setting_he = []
        if (val != old) {
            if (this.filter.tgl_awal && this.filter.tgl_akhir && this.kategoryChickin.includes(val)) {
                this.getPopulasi()
            }
            if (this.filter.tgl_awal && this.filter.tgl_akhir && this.kategorySetting.includes(val)) {
                this.getSetting()
            }
        }
      },
    },
    methods: {      
      setDate() {
          if (this.dates.length < 1) {
              ErrorService.message({
                  action: 'Peringatan',
                  message: 'Silahkan pilih tanggal terlebih dahulu',
              })
              return;
          }
          if (this.dates.length < 2) {
              this.dates.push(this.dates[0])
          }
          this.dates.sort()
          this.filter.tgl_awal = this.dates[0]
          this.filter.tgl_akhir = this.dates[1]
          this.modalDate = false
          this.errorDate = false
          this.filter.populasi = []
          this.filter.setting_he = []
          if (this.kategoryChickin.includes(this.filter.kategori)) {
              this.getPopulasi()
          }
          if (this.kategorySetting.includes(this.filter.kategori)) {
              this.getSetting()
          }
      },
      normalizer(node) {
        if (!node) return
        return {
          id: node.value,
          label: `${node.text} Chickin ${this.$options.filters.dateIndonesia(node.tanggal)}`,
          children: node.childrens,
        }
      },
      normalizerSHR(node) {
        if (!node) return
        return {
          id: node.value,
          label: `${node.text} Setting ${this.$options.filters.dateIndonesia(node.tanggal)}`,
          children: node.childrens,
        }
      },
      getPopulasi() {
          ReportService.getPeriodeChickin({ tgl_awal: this.filter.tgl_awal, tgl_akhir: this.filter.tgl_akhir })
          .then((res) => {
              if (!res.data.status) {
                  ErrorService.message(res.data)
                  this.opsPopulasi = []
                  return;
              }
              this.opsPopulasi = res.data.data
          })
          .catch((err) => {
              this.opsPopulasi = []
              ErrorService.status(err)
          })
      },
      getSetting() {
          ReportService.getPeriodeSetting({ tgl_awal: this.filter.tgl_awal, tgl_akhir: this.filter.tgl_akhir })
          .then((res) => {
              if (!res.data.status) {
                  ErrorService.message(res.data)
                  this.opsSettingSE = []
                  return;
              }
              this.opsSettingSE = res.data.data
          })
          .catch((err) => {
              this.opsSettingSE = []
              ErrorService.status(err)
          })
      },
      removeSpinner(button) { 
        button.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      },
      onSubmit(evt) {
        evt.preventDefault()
        this.$refs.formAdd.validate().then(success => {
          if (!success) {
              ErrorService.message({
                action: 'Peringatan',
                message: 'Silahkan lengkapi form data terlebih dahulu',
              })
              return;
          }
          
          // set spinner to submit button
          const submitButton = this.$refs["kt_submit"];
          submitButton.classList.add("spinner", "spinner-light", "spinner-right");

          const findTitle = this.opsData.find((itm) => itm.value == this.filter.kategori)
          this.filter.title = findTitle.text

          this.show = false
          this.curComponent = null
          this.$nextTick(() => {
            this.show = true
            this.curComponent = this.filter.display
          })
        
          // dummy delay
          setTimeout(() => {
              this.removeSpinner(submitButton)
              this.visible = true
              this.$nextTick(() => {
                  this.visible = false
              })
  
              window.scrollTo({
                  top: 100,
                  left: 0,
                  behavior: 'smooth'
              });
          }, 500);
        })
      },
      onReset(evt) {
        evt.preventDefault()
        // Reset our form values
        
          this.filter.display= null
          this.filter.kategori= null
          this.filter.tgl_awal= null
          this.filter.tgl_awal= null
          this.filter.populasi= []
          this.filter.setting_he= []
  
        // Trick to reset/clear native browser form validation state
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      }
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: "Report Weekly" }]);
      if (!this.currentUser.menu.statistik) {
        return this.$router.push({ name: 'dashboard'}).catch(()=>{})
      }
    },
  };
  </script>